import apiClient from './apiClient';

export async function listInterviews() {
  const { data } = await apiClient.get('/interviews');
  return Array.isArray(data) ? data : [];
}

export async function getInterview(id) {
  const { data } = await apiClient.get(`/interviews/${id}`);
  return data;
}

/**
 * @param {{
 *   interviewDate: string,
 *   client: string,
 *   interviewRound: string,
 *   positionTitle: string,
 *   interviewer: string,
 *   candidate: string,
 *   questions: string[],
 * }} payload
 */
export async function createInterview(payload) {
  const { data } = await apiClient.post('/interviews', payload);
  return data;
}

export async function updateInterview(id, payload) {
  const { data } = await apiClient.put(`/interviews/${id}`, payload);
  return data;
}

export async function deleteInterview(id) {
  await apiClient.delete(`/interviews/${id}`);
}
